import React, { useEffect, useState } from "react";
import { whatsAppPhoneNumber } from "../config";

export default function WhatsAppButton() {
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      setAtBottom(scrollY + windowHeight >= docHeight - 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <a
      href={`https://wa.me/${whatsAppPhoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed right-6 z-[9999] sm:hidden flex items-center justify-center rounded-full bg-gray-700 shadow-lg transition-all duration-300 w-20 h-20 ${
        atBottom ? "bottom-[6rem]" : "bottom-6"
      }`}
      style={{ width: 80, height: 80, boxShadow: "0 4px 16px rgba(0,0,0,0.18)" }}
      aria-label="Contact via WhatsApp"
    >
      {/* WhatsApp SVG icon from simpleicons.org (monochrome, white) */}
      <svg width="55" height="55" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.941 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.151-.172.2-.296.298-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51-.173-.008-.372-.01-.571-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.077 4.363.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.617h-.001a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374A9.86 9.86 0 012.1 12.309c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.995c-.003 5.45-4.437 9.884-9.888 9.884zm8.413-18.297A11.815 11.815 0 0011.988 0C5.373 0 .111 5.262.109 11.873c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.868 11.868 0 005.626 1.432h.005c6.616 0 11.879-5.262 11.882-11.873a11.82 11.82 0 00-3.485-8.423z"/>
      </svg>
    </a>
  );
}